import { render, staticRenderFns } from "./Contactar.vue?vue&type=template&id=2b0ca83d&scoped=true"
var script = {}
import style0 from "./Contactar.vue?vue&type=style&index=0&id=2b0ca83d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0ca83d",
  null
  
)

export default component.exports